<template>
	<div>
		<div id="tb10" style="width: 100%;height: 350px;"></div>
	</div>
</template>

<script>
	export default {
		props: ["rcxx", "isTrue"],
		data() {
			return {

			}
		},
		mounted() {
			this.getJrqk()
		},
		methods: {
			getJrqk() {
				let myChart = this.echarts.init(document.getElementById('tb10'), 'dark');
				setTimeout(() => {
					this.$http.get("/api/checkInApply/countTalentByLevel").then(res => {
						let option = {
							backgroundColor: '#0F0B26',
							title: {
								text: '停车费'
							},
							legend: {},
							tooltip: {},
							color:['#00a8fb', '#ff6c83','#26e9c5'],
							dataset: {
								dimensions: ['product', '固定停车费', '临时车费', '商户优惠停车费'],
								source: [{
										product: '1月',
										固定停车费: 43.3,
										临时车费: 85.8,
										商户优惠停车费: 93.7
									},
									{
										product: '2月',
										固定停车费: 83.1,
										临时车费: 73.4,
										商户优惠停车费: 55.1
									},
									{
										product: '3月',
										固定停车费: 86.4,
										临时车费: 65.2,
										商户优惠停车费: 82.5
									},
									{
										product: '4月',
										固定停车费: 72.4,
										临时车费: 53.9,
										商户优惠停车费: 39.1
									}
								]
							},
							xAxis: {
								type: 'category'
							},
							yAxis: {},
							// Declare several bar series, each will be mapped
							// to a column of dataset.source by default.
							series: [{
								type: 'bar'
							}, {
								type: 'bar'
							}, {
								type: 'bar'
							}]
						};
						myChart.setOption(option);
					})
				}, 100)
			}
		}
	}
</script>

<style scoped="scoped">
</style>
